export const mobile = {
  data() {
    return {
      isTablet: false,
      isMobile: false,
      bodyWidth: 0,
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkResize);
  },
  mounted() {
    this.bodyWidth = window.innerWidth;
    window.addEventListener("resize", this.checkResize);
    if (this.bodyWidth < 992) this.isTablet = true;
    if (this.bodyWidth < 768) this.isMobile = true;
  },
  methods: {
    checkResize() {
      this.bodyWidth = window.innerWidth;
      this.bodyWidth < 992 ? (this.isTablet = true) : (this.isTablet = false);
      this.bodyWidth < 768 ? (this.isMobile = true) : (this.isMobile = false);
    },
  },
};
